import * as PIXI from "pixi.js";
import Layers from "../../layers/Layers";
import { BaseSButtonStyle } from "../../types/Interface";


export default class BaseSimpleButton extends PIXI.Container {
  Layers = Layers.getInstance();
  bg: PIXI.Graphics;
  title: PIXI.Text;
  style: BaseSButtonStyle;
  titleText: string
  handleFunc: () => void;
  constructor(title: string, style: BaseSButtonStyle, handleFunc: () => void) {
    super();
    this.style = style;
    this.titleText = title;
    this.handleFunc = handleFunc;
    this.addBg(style);
    this.addTitle(title, style.titleColor);
    this.handleEvents();
    this.addToLayer();
  }
  private addToLayer = () =>  this.Layers.UI.addChild(this);
  
  handleEvents() {
    this.interactive = true;
    this.cursor = "pointer";

    const pressedFunc = () => {
      this.drawBg(this.style, this.style.pressedColor);
      this.handleFunc();
    }

    this.on("mouseover", () => this.drawBg(this.style, this.style.hoverColor));
    this.on("mouseup", () => this.drawBg(this.style, this.style.hoverColor));
    this.on("mouseleave", () => this.drawBg(this.style, this.style.defaultColor));
    this.on("mousedown", () => pressedFunc());
    this.on("touchstart", () => pressedFunc());
    this.on("touchend", () => this.drawBg(this.style, this.style.defaultColor));
  }
  private addTitle(title: string, color: number) {
    this.title = new PIXI.Text({ text: title });
    this.title.style = {
      fill: color,
      fontSize: this.style.titleFontSize,
      wordWrap: true,
      wordWrapWidth: this.style.wordWrapWidth,
      align: "center",
    }

    this.title.anchor.set(.5);
    this.addChild(this.title);
  }
  private addBg(style: BaseSButtonStyle) {
    this.bg = new PIXI.Graphics();
    this.addChild(this.bg);
    this.drawBg(style, style.defaultColor);
  }
  private drawBg(style: BaseSButtonStyle, color: number) {
    this.bg.clear();
    this.bg.roundRect(-style.width / 2, -style.height / 2, style.width, style.height, style.borderRadius)
      .stroke({ width: 5, color: style.borderColor })
      .fill(color);
  }
  handleTitle(title: string, color: number) {
    this.titleText = title;
    this.title.text = title;
    this.title.style.fill = color;
  }  
}